import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export type ZogTipo   = 'NF' | 'CTE' | 'AMBOS';
export type ZogNovos  = '1' | '2';                  // 1=so novos, 2=todos
export type ZogOrigem = 'ARQUIVEI' | 'MANUAL' | 'AMBOS';
export type ZogStatus = '1' | '2' | '3' | '4';      // PEN / PROC / OK / ERR

export interface SolicitarDownloadReq {
  dataIni: string;     // ISO yyyy-mm-dd
  dataFim: string;
  tipo:    ZogTipo;
  novos:   ZogNovos;
  origem:  ZogOrigem;
  email?:  string;
}

export interface SolicitacaoDownload {
  recno:           number;
  cod:             string;
  filial:          string;
  filOri:          string;
  cnpj:            string;
  dataInicial:     string;
  dataFinal:       string;
  tipo:            ZogTipo;
  novos:           ZogNovos;
  origem:          ZogOrigem;
  status:          ZogStatus;
  usuario:         string;
  nomeUsuario:     string;
  email:           string;
  dataSolicitacao: string;
  horaSolicitacao: string;
  dataProcesso:    string;
  horaProcesso:    string;
  objetoZip:       string;
  dataExpira:      string;
  mensagemErro:    string;
  qtdArquivos:     number;
  tamanhoZip:      number;
  urlZip:          string;
}

interface CreateResp { success: boolean; data: SolicitacaoDownload; }
interface ListResp   { success: boolean; data: SolicitacaoDownload[]; page: number; pageSize: number; hasNext: boolean; }

export interface PageResult<T> {
  data: T[];
  hasNext: boolean;
}

@Injectable({ providedIn: 'root' })
export class DownloadPdfService {
  private readonly base = 'portalnf/download';

  constructor(private http: HttpClient) {}

  solicitar(req: SolicitarDownloadReq): Observable<SolicitacaoDownload> {
    return this.http.post<CreateResp>(`${this.base}/solicitar`, req).pipe(
      map(r => r.data)
    );
  }

  listar(page = 1, pageSize = 20): Observable<PageResult<SolicitacaoDownload>> {
    const params = new HttpParams()
      .set('page', String(page))
      .set('pageSize', String(pageSize));
    return this.http.get<ListResp>(`${this.base}/solicitacoes`, { params }).pipe(
      map(r => ({ data: r.data ?? [], hasNext: !!r.hasNext }))
    );
  }
}
